



























import Vue from "vue";
import { mapGetters } from "vuex";
import { LogOutIcon } from "vue-feather-icons";
import { parseMarkdown } from "@/services/mardown-parser";
import { Anamnese } from "@/types";

const markdownDocument = `
## Présentation générale

[Date ??](presentation-generale-date)

[Prénom ??](presentation-generale-prenom)

[Nom ??](presentation-generale-nom)

[Âge ??](presentation-generale-age)

[Classe ??](presentation-generale-classe)

## Cite 3 mots...

[Enfant ??](trois-mots-enfant)

[Parents pour l'enfant ??](trois-mots-parents-pour-enfant)
`;

export default Vue.extend({
  name: "AnamnesePage",
  components: {
    LogOutIcon,
  },
  data() {
    return {
      anamneseHtml: "",
    };
  },
  async beforeMount() {
    this.anamneseHtml = parseMarkdown(markdownDocument);
  },
  async mounted(): Promise<void> {
    await this.$store.dispatch("anamnese/fetchAnamnese");
    this.populateFields(this.getDocument);
    this.setupListeners();
  },
  methods: {
    async logout(): Promise<void> {
      await this.$store.dispatch("authentication/logout");
      await this.$router.push({ name: "LoginPage" });
    },
    createInputListener(el: HTMLInputElement) {
      return () =>
        this.$store.dispatch("anamnese/setField", {
          name: el.id,
          value: el.value,
        });
    },
    setupListeners(): void {
      const anamneseForm = document.getElementById(
        "anamneseForm"
      ) as HTMLElement;
      const inputFields = anamneseForm.querySelectorAll("input");

      inputFields.forEach((el) => {
        el.oninput = this.createInputListener(el);
      });
    },
    populateFields(anamnese: Anamnese): void {
      Object.entries(anamnese).forEach(
        ([elementId, value]) =>
          ((document.getElementById(
            elementId
          ) as HTMLInputElement).value = value)
      );
    },
  },
  computed: {
    ...mapGetters({
      getDocument: "anamnese/getDocument",
      isSaveInProgress: "apiRequestStatus/isSaveAnamneseInProgress",
      isSaveSuccessful: "apiRequestStatus/isSaveAnamneseSuccessful",
      isSaveFailed: "apiRequestStatus/isSaveAnamneseFailed",
      isFetchInProgress: "apiRequestStatus/isFetchAnamneseInProgress",
      isFetchSuccessful: "apiRequestStatus/isFetchAnamneseSuccessful",
      isFetchFailed: "apiRequestStatus/isFetchAnamneseFailed",
    }),
  },
});
